module.exports = __webpack_public_path__ + "static/img/qd-anniu.c467539b.png";